import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Row from 'react-bootstrap/lib/Row';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import Icon from 'components/Icon/Icon';
import TimeAgo from 'components/TimeAgo/TimeAgo';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import MediaPlayer from 'components/Shared/MediaPlayer/MediaPlayer';
import CollectionSinglePage from '../CollectionSinglePage/CollectionSinglePage';
import styles from './ProjectContent.module.scss';
import AlertBox from 'components/AlertBox/AlertBox';
import { useDispatch } from 'react-redux';
import { deleteProject } from 'redux/modules/portfolio';
import Markdown from 'components/Shared/Markdown';

const ProjectContent = ({
  collection,
  collectionTotal,
  credits,
  creditsLink,
  creditsTotal,
  hasReported,
  likeState,
  likesTotal,
  loggedInUser,
  onDownload,
  onReport,
  owner,
  onLoadMoreCollection,
  project,
  toggleLike,
  showCollections,
  onShowCollections,
  loadingCollection,
  suggestedRoles,
  suggestedSkills,
}) => {
  const dispatch = useDispatch();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const index = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return Math.round(bytes / Math.pow(1024, index), 2) + ' ' + sizes[index];
  };

  const viewerIsOwner =
    owner && loggedInUser ? loggedInUser.id === owner.id : false;
  const tooltipDownload = project ? (
    <Tooltip id="tooltip">
      Download project ({bytesToSize(project.size)})
    </Tooltip>
  ) : null;
  const tooltipEdit = project ? (
    <Tooltip id="tooltip">Edit project</Tooltip>
  ) : null;
  const tooltipDelete = project ? (
    <Tooltip id="tooltip">Delete project</Tooltip>
  ) : null;
  const tooltipLike = project ? (
    <Tooltip id="tooltip">Like this project</Tooltip>
  ) : null;
  const projectCredits = credits.length > 0 ? credits.slice(0, 4) : [];

  const sliderResponsive = [];
  if (collectionTotal <= 3) {
    sliderResponsive.push({ breakpoint: 100000, settings: 'unslick' });
  } else if (collectionTotal <= 4) {
    sliderResponsive.push({
      breakpoint: 399,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    });
    sliderResponsive.push({
      breakpoint: 480,
      settings: { slidesToShow: 4, slidesToScroll: 4 },
    });
    sliderResponsive.push({ breakpoint: 100000, settings: 'unslick' });
  } else if (collectionTotal <= 5) {
    sliderResponsive.push({
      breakpoint: 399,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    });
    sliderResponsive.push({
      breakpoint: 480,
      settings: { slidesToShow: 4, slidesToScroll: 4 },
    });
    sliderResponsive.push({
      breakpoint: 520,
      settings: { slidesToShow: 5, slidesToScroll: 5 },
    });
    sliderResponsive.push({ breakpoint: 100000, settings: 'unslick' });
  } else if (collectionTotal <= 6) {
    sliderResponsive.push({
      breakpoint: 399,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    });
    sliderResponsive.push({
      breakpoint: 480,
      settings: { slidesToShow: 4, slidesToScroll: 4 },
    });
    sliderResponsive.push({
      breakpoint: 560,
      settings: { slidesToShow: 5, slidesToScroll: 5 },
    });
    sliderResponsive.push({
      breakpoint: 640,
      settings: { slidesToShow: 6, slidesToScroll: 6 },
    });
    sliderResponsive.push({ breakpoint: 100000, settings: 'unslick' });
  } else if (collectionTotal <= 7) {
    sliderResponsive.push({
      breakpoint: 399,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    });
    sliderResponsive.push({
      breakpoint: 480,
      settings: { slidesToShow: 4, slidesToScroll: 4 },
    });
    sliderResponsive.push({
      breakpoint: 560,
      settings: { slidesToShow: 5, slidesToScroll: 5 },
    });
    sliderResponsive.push({
      breakpoint: 640,
      settings: { slidesToShow: 6, slidesToScroll: 6 },
    });
    sliderResponsive.push({
      breakpoint: 680,
      settings: { slidesToShow: 7, slidesToScroll: 7 },
    });
    sliderResponsive.push({ breakpoint: 100000, settings: 'unslick' });
  } else if (collectionTotal <= 8) {
    sliderResponsive.push({
      breakpoint: 399,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    });
    sliderResponsive.push({
      breakpoint: 480,
      settings: { slidesToShow: 4, slidesToScroll: 4 },
    });
    sliderResponsive.push({
      breakpoint: 560,
      settings: { slidesToShow: 5, slidesToScroll: 5 },
    });
    sliderResponsive.push({
      breakpoint: 640,
      settings: { slidesToShow: 6, slidesToScroll: 6 },
    });
    sliderResponsive.push({
      breakpoint: 700,
      settings: { slidesToShow: 7, slidesToScroll: 7 },
    });
    sliderResponsive.push({
      breakpoint: 760,
      settings: { slidesToShow: 8, slidesToScroll: 8 },
    });
    sliderResponsive.push({ breakpoint: 100000, settings: 'unslick' });
  } else if (collectionTotal <= 9) {
    sliderResponsive.push({
      breakpoint: 399,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    });
    sliderResponsive.push({
      breakpoint: 480,
      settings: { slidesToShow: 4, slidesToScroll: 4 },
    });
    sliderResponsive.push({
      breakpoint: 560,
      settings: { slidesToShow: 5, slidesToScroll: 5 },
    });
    sliderResponsive.push({
      breakpoint: 640,
      settings: { slidesToShow: 6, slidesToScroll: 6 },
    });
    sliderResponsive.push({
      breakpoint: 700,
      settings: { slidesToShow: 7, slidesToScroll: 7 },
    });
    sliderResponsive.push({
      breakpoint: 1200,
      settings: { slidesToShow: 8, slidesToScroll: 8 },
    });
    sliderResponsive.push({ breakpoint: 100000, settings: 'unslick' });
  } else {
    sliderResponsive.push({
      breakpoint: 399,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    });
    sliderResponsive.push({
      breakpoint: 480,
      settings: { slidesToShow: 4, slidesToScroll: 4 },
    });
    sliderResponsive.push({
      breakpoint: 560,
      settings: { slidesToShow: 5, slidesToScroll: 5 },
    });
    sliderResponsive.push({
      breakpoint: 640,
      settings: { slidesToShow: 6, slidesToScroll: 6 },
    });
    sliderResponsive.push({
      breakpoint: 700,
      settings: { slidesToShow: 7, slidesToScroll: 7 },
    });
    sliderResponsive.push({
      breakpoint: 1200,
      settings: { slidesToShow: 8, slidesToScroll: 8 },
    });
  }

  const nonDownloadableMediaType = {
    video: true,
    audio: true,
    image: true,
    text: true,
  };

  const handleConfirm = () => {
    dispatch(deleteProject(project.id));
    setShowDeleteModal(false);
    window.location.href = `/` + loggedInUser.username;
  };

  // Only allow downloads for projects that are set as downloadable, and are not of the non-downloadable media types
  const allowDownload =
    project &&
    project.preferences &&
    project.preferences.downloadable &&
    !nonDownloadableMediaType[project.mediaType];

  return (
    <>
      <AlertBox
        show={showDeleteModal}
        title="Delete Project"
        text={'Are you sure you want to delete this project?'}
        confirmButtonText={"Yes I'm sure"}
        onConfirm={() => handleConfirm()}
        onCancel={() => setShowDeleteModal(false)}
      />
      <Row style={{ marginTop: '-15px', padding: '20px', paddingTop: '40px' }}>
        <Col className="no-padding" xs={12}>
          <MediaPlayer
            project={project}
            onZoom={() => {
              if (project.collection && onShowCollections) {
                onShowCollections(project.id);
                return false;
              }

              return true;
            }}
            user={owner}
          />
        </Col>
        <Col className="mt++" xs={12}>
          <div className={styles.content}>
            {project && owner ? (
              <>
                <div className={styles.titleContainer}>
                  <h1
                    key="content_1"
                    className="mb- lato-bold fs-18 no-margin"
                    style={{ color: '#333' }}
                  >
                    {project.title}
                  </h1>
                  {viewerIsOwner && (
                    <div>
                      <OverlayTrigger placement="top" overlay={tooltipEdit}>
                        <Button
                          href={project.links.edit}
                          bsStyle="default"
                          className={`ml- ${styles.buttonIcon}`}
                        >
                          <SvgIcon icon="pencil" color="black" size="15" />
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger placement="top" overlay={tooltipDelete}>
                        <Button
                          bsStyle="default"
                          className={`ml- ${styles.buttonIcon}`}
                          onClick={() => setShowDeleteModal(true)}
                        >
                          <SvgIcon icon="trash" color="black" size="15" />
                        </Button>
                      </OverlayTrigger>
                    </div>
                  )}
                </div>
                <p key="content_2" className="fs-16 text-muted">
                  <Link
                    to={owner.links.main_relative}
                    title={owner.displayname}
                  >
                    <strong style={{ color: '#3B3C3D' }}>
                      {owner.displayname}
                    </strong>
                  </Link>
                  <br />
                  Published{' '}
                  <time dateTime={project.created_at}>
                    <TimeAgo timestamp={project.created_at} />
                  </time>
                </p>
              </>
            ) : (
              <>
                <span key="content_3" className={styles.loading}></span>
                <span key="content_4" className={styles.loading}></span>
              </>
            )}
          </div>
          {collection.length > 0 ? (
            <div>
              <div className={styles.divider}></div>
              <div className={styles.content}>
                <p>
                  {collectionTotal} project{collectionTotal === 1 ? '' : 's'}:
                </p>
                <div className={styles.slider}>
                  <Slider
                    arrows
                    useCSS
                    responsive={sliderResponsive}
                    slidesToShow={
                      collection.length < 10 ? collection.length : 10
                    }
                    slidesToScroll={
                      collection.length < 10 ? collection.length : 10
                    }
                    infinite
                    nextArrow={
                      <span>
                        <SvgIcon
                          icon="chevron-right"
                          color="gray"
                          size="20"
                          style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                          }}
                        />
                      </span>
                    }
                    prevArrow={
                      <span>
                        <SvgIcon
                          icon="chevron-left"
                          color="gray"
                          size="20"
                          style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                          }}
                        />
                      </span>
                    }
                    afterChange={() =>
                      onLoadMoreCollection ? onLoadMoreCollection() : null
                    }
                  >
                    {collection.map((collectionProject) => {
                      const style = {
                        width: '70px',
                        height: '70px',
                        display: 'inline-block',
                        marginRight: '10px',
                        borderRadius: '2px',
                      };

                      if (project.id === collectionProject.id) {
                        style.border = '2px solid #40a0f5';
                      }

                      return (
                        <div
                          key={collectionProject.id}
                          className="pointer"
                          style={{ display: 'inline' }}
                          onClick={() =>
                            onShowCollections
                              ? onShowCollections(collectionProject.id)
                              : null
                          }
                        >
                          <Thumbnail
                            thumbnails={collectionProject.thumbnails}
                            style={style}
                            square
                          />
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </div>
          ) : null}
          {collection.length > 0 && showCollections ? (
            <CollectionSinglePage
              owner={owner}
              collection={collection}
              loading={loadingCollection}
              onClose={() =>
                onShowCollections ? onShowCollections(false) : null
              }
              loadMore={onLoadMoreCollection}
              scrollTo={showCollections}
            />
          ) : null}
          <div className={styles.divider}></div>
          {project ? (
            [
              <div key="content_5" className={styles.content}>
                <OverlayTrigger placement="top" overlay={tooltipLike}>
                  <Button
                    disabled={viewerIsOwner}
                    onClick={toggleLike}
                    bsStyle="default"
                    className={`${styles.buttonHeart} ${
                      viewerIsOwner ? styles.disable : null
                    }`}
                  >
                    <Icon
                      className={`${styles.iconHeart} ${
                        likeState ? styles.liked : ''
                      }`}
                      icon="&#xf004;"
                    />
                  </Button>
                </OverlayTrigger>
                <span className={styles.likeCounter}>{likesTotal}</span>
                {allowDownload ? (
                  <OverlayTrigger placement="top" overlay={tooltipDownload}>
                    <Button
                      onClick={onDownload}
                      bsStyle="default"
                      className={`hidden-xs ml- ${styles.buttonIcon}`}
                    >
                      <span style={{ verticalAlign: 'top' }}>Download</span>{' '}
                      <SvgIcon
                        icon="arrow-down"
                        style={{ verticalAlign: 'sub' }}
                        color="black"
                        size="15"
                      />
                    </Button>
                  </OverlayTrigger>
                ) : null}
              </div>,
              credits.length > 0 ? (
                <div
                  key="content_6"
                  className={`visible-xs-block visible-sm-block ${styles.divider}`}
                ></div>
              ) : (
                <noscript key="content_6" />
              ),
              credits.length > 0 ? (
                <div
                  key="content_7"
                  className={`visible-xs-block visible-sm-block ${styles.content} cf`}
                >
                  <ul className={styles.creditList}>
                    <li className={styles.creditListItem}>
                      <strong className={styles.creditTitle}>
                        {creditsTotal === 1
                          ? 'Project creator'
                          : 'Project creators'}
                      </strong>
                    </li>
                    {projectCredits.length > 0 &&
                      projectCredits.map((credit, index) => {
                        return (
                          <li key={index} className={styles.creditListItem}>
                            <a href={creditsLink}>
                              <Thumbnail
                                thumbnails={credit.user.avatars}
                                className={styles.avatars}
                                circle
                              />
                            </a>
                          </li>
                        );
                      })}
                    {projectCredits && projectCredits.length > 3 && (
                      <li
                        key={5}
                        className={`${styles.creditListItem} ${styles.creditListItemMore}`}
                      >
                        <a href={creditsLink}>
                          <Icon className={styles.iconMore} icon="&#xe600;" />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              ) : (
                <noscript key="content_7" />
              ),
              project.description !== '' ? (
                <div key="content_8" className={styles.divider}></div>
              ) : (
                <noscript key="content_8" />
              ),
              project.description !== '' ? (
                <div key="content_9" className={`${styles.content}`}>
                  <Markdown
                    text={project.description}
                    suggestedRoles={suggestedRoles}
                    suggestedSkills={suggestedSkills}
                  />
                </div>
              ) : (
                <noscript key="content_9" />
              ),
              <div key="content_10" className="cf">
                <Button
                  bsSize="xs"
                  className={styles.reportButton}
                  onClick={onReport}
                  style={{
                    color: hasReported ? '#d9534f' : '#777',
                  }}
                  disabled={viewerIsOwner || hasReported}
                  title="Report this project"
                  aria-label="Report this project"
                >
                  <Icon icon="&#xe618;" />
                </Button>
              </div>,
            ]
          ) : (
            <div className={styles.content}>
              <span className={styles.loading}></span>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

ProjectContent.propTypes = {
  collection: PropTypes.array,
  collectionTotal: PropTypes.number,
  credits: PropTypes.array,
  creditsLink: PropTypes.string,
  creditsTotal: PropTypes.number,
  hasReported: PropTypes.bool,
  likeState: PropTypes.bool,
  likesTotal: PropTypes.number,
  loggedInUser: PropTypes.object,
  onDownload: PropTypes.func,
  onReport: PropTypes.func,
  owner: PropTypes.object,
  onLoadMoreCollection: PropTypes.func,
  project: PropTypes.object,
  suggestedRoles: PropTypes.array,
  suggestedSkills: PropTypes.array,
  toggleLike: PropTypes.func,
  showCollections: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onShowCollections: PropTypes.func,
  loadingCollection: PropTypes.bool,
};

ProjectContent.defaultProps = {
  collection: [],
  collectionTotal: 0,
  hasReported: false,
  showCollections: false,
  loadingCollection: false,
};

export default ProjectContent;
